import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductoIndexComponent } from './producto-index/producto-index.component';
import { ProductoCreateComponent } from './producto-create/producto-create.component';
import { ProductoUpdateComponent } from './producto-update/producto-update.component';
import { ProductoViewComponent } from './producto-view/producto-view.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { RecetaCreateComponent } from './receta-create/receta-create.component';
import { RecetaUpdateComponent } from './receta-update/receta-update.component';
import { RecetaViewComponent } from './receta-view/receta-view.component';
import { NgxMaskModule } from 'ngx-mask';
import { ProductoStocksComponent } from './producto-stocks/producto-stocks.component';
import { ProductoHistorialComponent } from './producto-historial/producto-historial.component';
import { ProductoStockCriticoComponent } from './producto-stock-critico/producto-stock-critico.component';

const routes: Routes = [
  { path: 'index', component: ProductoIndexComponent },
  { path: 'stock-critico', component: ProductoStockCriticoComponent },
  { path: '**', redirectTo: 'index' }
];

@NgModule({
  declarations: [
    ProductoIndexComponent,
    ProductoCreateComponent,
    ProductoUpdateComponent,
    ProductoViewComponent,
    RecetaCreateComponent,
    RecetaUpdateComponent,
    RecetaViewComponent,
    ProductoStocksComponent,
    ProductoHistorialComponent,
    ProductoStockCriticoComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
    NgbNavModule,
    NgxMaskModule.forChild()
  ]
})
export class ProductoModule { }
